module.exports = __webpack_public_path__ + "static/media/sample-default-bg-cover.bd347deb.jpg";